'use es6';

import withDebouncedInput from 'ContentComponents/decorators/withDebouncedInput';
import { ThemeSortingTypes } from 'ContentUtils/constants/ThemeSortingTypes';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SearchInput as FoundationsSearchInput } from 'foundations-components/transitional/components/SearchInput';
import { Select } from 'foundations-components/transitional/components/Select';
import { ToolBar } from 'foundations-components/transitional/components/ToolBar';
import { ToolBarGroup } from 'foundations-components/transitional/components/ToolBarGroup';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.themes.filterBar.${key}`;
const DebouncedSearchInput = withDebouncedInput(FoundationsSearchInput);
export const SortFilter = ({
  sortType,
  onSortingChange
}) => /*#__PURE__*/_jsxs(TFlex, {
  alignItems: "center",
  children: [/*#__PURE__*/_jsx(FormattedMessage, {
    message: i18nKey('sortLabel')
  }), /*#__PURE__*/_jsx(Select, {
    buttonUse: "link",
    value: sortType,
    options: [{
      text: I18n.text(i18nKey('sortTypes.mostUsed')),
      value: ThemeSortingTypes.MOST_USED
    }, {
      text: I18n.text(i18nKey('sortTypes.alphabetical')),
      value: ThemeSortingTypes.ALPHABETICAL
    }],
    onChange: onSortingChange,
    marginInlineStart: "200"
  })]
});
export const SearchInput = ({
  placeholder,
  onChange,
  searchValue
}) => /*#__PURE__*/_jsx(DebouncedSearchInput, {
  placeholder: placeholder,
  onChange: onChange,
  value: searchValue
});
export const FilterBar = ({
  searchInput,
  sortFilter,
  sourceFilter = null,
  templateFolderFilter = null
}) => /*#__PURE__*/_jsxs(ToolBar, {
  use: "filter-bar",
  marginBlockStart: "0",
  paddingBlockStart: "0",
  children: [/*#__PURE__*/_jsxs(ToolBarGroup, {
    marginInlineEnd: "600",
    children: [sortFilter, sourceFilter, templateFolderFilter]
  }), /*#__PURE__*/_jsx(ToolBarGroup, {
    children: searchInput
  })]
});